"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAdAccountMemberRoleRequestToJSON = exports.UpdateAdAccountMemberRoleRequestFromJSONTyped = exports.UpdateAdAccountMemberRoleRequestFromJSON = exports.instanceOfUpdateAdAccountMemberRoleRequest = void 0;
var runtime_1 = require("../runtime");
var AdAccountRole_1 = require("./AdAccountRole");
/**
 * Check if a given object implements the UpdateAdAccountMemberRoleRequest interface.
 */
function instanceOfUpdateAdAccountMemberRoleRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateAdAccountMemberRoleRequest = instanceOfUpdateAdAccountMemberRoleRequest;
function UpdateAdAccountMemberRoleRequestFromJSON(json) {
    return UpdateAdAccountMemberRoleRequestFromJSONTyped(json, false);
}
exports.UpdateAdAccountMemberRoleRequestFromJSON = UpdateAdAccountMemberRoleRequestFromJSON;
function UpdateAdAccountMemberRoleRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : (0, AdAccountRole_1.AdAccountRoleFromJSON)(json['role']),
    };
}
exports.UpdateAdAccountMemberRoleRequestFromJSONTyped = UpdateAdAccountMemberRoleRequestFromJSONTyped;
function UpdateAdAccountMemberRoleRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'role': (0, AdAccountRole_1.AdAccountRoleToJSON)(value.role),
    };
}
exports.UpdateAdAccountMemberRoleRequestToJSON = UpdateAdAccountMemberRoleRequestToJSON;
